import { Endpoint } from '../../constants/endpoints';

export const setLocator = [
  {
    entry       : 'personName',
    idColumn    : 'personCode',
    key         : 'personCode',
    keyLabel    : 'text.code',
    label       : 'text.device-professional',
    nameColumn  : 'personName',
    route       :  Endpoint.GET_PHYSICAL_PERSONS,
    type        : 'PHYSICAL_PERSON'
  },
  {
    entry       : 'personName',
    idColumn    : 'personCode',
    key         : 'personCode',
    keyLabel    : 'text.code',
    label       : 'text.device-professional',
    nameColumn  : 'personName',
    route       :  Endpoint.GET_PROFESSIONAL_PERSON,
    type        : 'PROFESSIONAL_PERSON'
  },
  {
    entry       : 'description' ,
    idColumn    : 'id' ,
    key         : 'id',
    keyLabel    : 'text.code',
    label       : 'tws.sncp-record-diseases',
    nameColumn  : 'description',
    route       : Endpoint.GET_SAE,
    type        : 'SAE_SEARCH'
  }
];
